import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Check } from 'lucide-react';
import { whyChooseUs } from '../data/mockData';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const WhyChooseUsSection = ({ onOpenContactForm }) => {
  const section = useScrollAnimation({ threshold: 0.15 });

  return (
    <section data-testid="why-choose-section" ref={section.ref} className="py-24 md:py-32 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10">
        <div className="flex flex-col lg:grid lg:grid-cols-2 gap-16 items-stretch">
          {/* Left - Image spanning full height */}
          <div className={`scroll-slide-left ${section.isVisible ? 'scroll-visible' : ''}`}>
            <div className="relative overflow-hidden border border-[#E5E7EB] h-full min-h-[400px]">
              <img
                src="https://images.unsplash.com/photo-1632152053560-2ff69f7981f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxsZWdhbCUyMGRvY3VtZW50JTIwcGVuJTIwY2xvc2V1cHxlbnwwfHx8fDE3NzYxOTgwMjl8MA&ixlib=rb-4.1.0&q=85"
                alt="Legal document"
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right - Checklist + CTA */}
          <div className={`scroll-slide-right scroll-delay-2 ${section.isVisible ? 'scroll-visible' : ''}`}>
            <span className="text-xs font-bold uppercase tracking-widest text-[#FF1010] block mb-3">Why Us</span>
            <h2 className="text-3xl sm:text-4xl font-black tracking-tighter text-[#111827] leading-tight mb-8 uppercase" style={{ fontFamily: "'Outfit', sans-serif" }}>
              We Don't Cut Corners.<br />Neither Should You.
            </h2>

            <div className="space-y-5 mb-10">
              {whyChooseUs.map((item) => (
                <div key={item.id} data-testid={`why-choose-card-${item.id}`} className="flex gap-4 group">
                  <div className="w-8 h-8 bg-[#FF1010] flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Check className="w-4 h-4 text-white" strokeWidth={3} />
                  </div>
                  <div>
                    <h4 className="text-sm font-black text-[#111827] uppercase tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
                      {item.title}
                    </h4>
                    <p className="text-sm text-[#4B5563] leading-relaxed mt-1">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <Button data-testid="why-choose-cta" onClick={onOpenContactForm} className="bg-[#FF1010] hover:bg-[#CC0000] text-white font-bold px-8 py-5 text-sm rounded-none uppercase tracking-wider btn-brutal">
              Start Your Registration Now <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
